<template>
    <b-row>
        <slot name="add">
            <b-col lg="12" class="mb-1">
                <div class="d-flex flex-row justify-content-center align-items-center" style="height: 100%;">
                    <b-card-text class="text-center">
                        <b-container>
                            <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-primary" to="/tableau_gestions/add">
                                <feather-icon class="text-primary mr-50 align-middle" icon="PlusSquareIcon" size="30"/>
                                <span class="text-primary align-middle">Ajouter Tableau de Gestion</span>
                            </b-button>
                        </b-container>
                    </b-card-text>
                </div>
            </b-col>
        </slot>

        <b-col lg="12">
            <b-card>
                <!-- table -->
                <vue-good-table
                    :columns="columns"
                    :rows="tableauxGestion"
                    :pagination-options="{enabled: true, perPage:pageLength}"
                    :initialSortBy="initialSortBy"
                    :theme="isDark ? 'nocturnal' : ''"
                    styleClass="vgt-table bordered tableau"
                    >

                >
                    <template #emptystate>
                        <div class="text-center"> Aucun Tableau de Gestion n'a été trouvé </div>
                    </template>

                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field === 'action'" class="text-nowrap">
                            <b-button
                                size="sm"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="success"
                                class="btn-icon"
                                @click="editTableauGestion(props.row.id)"
                            >
                                <feather-icon icon="Edit2Icon" size="1x"/>
                            </b-button>

                            <b-button
                                size="sm"
                                v-if="deletable(props.row)"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="danger"
                                class="btn-icon ml-1"
                                @click="confirmDeleteTableauGestion(props.row.id, 'du ' + moment(props.row.datePointGestion, 'YYYY-MM-DD').format('DD/MM/YYYY'), removeTableauGestionFromList)"
                            >
                                <feather-icon icon="TrashIcon" size="1x"/>
                            </b-button>
                        </span>

                        <template v-else-if="props.column.field === 'valid'" class="text-nowrap">
                            <div class="text-center text-primary"><feather-icon icon="CheckCircleIcon" size="18" v-if="props.row.valid" /></div>
                        </template>

                        <template v-else-if="props.column.field === 'datePointGestion'" class="text-nowrap">
                            {{moment(props.row.datePointGestion, 'YYYY-MM-DD').format('DD/MM/YYYY')}}
                        </template>
                    </template>

                    <template
                        slot="pagination-bottom"
                        slot-scope="props"
                    >
                        <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap">
                            </span>
                            <b-form-select
                                v-model="pageLength"
                                :options="['25', '50', '100']"
                                class="mx-1"
                                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                            />
                            <span class="text-nowrap "> sur {{ props.total }} Tableaux </span>
                        </div>
                        <div>
                            <b-pagination
                            :value="1"
                            :total-rows="props.total"
                            :per-page="pageLength"
                            first-number
                            last-number
                            align="right"
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mt-1 mb-0"
                            @input="(value)=>props.pageChanged({currentPage:value})"
                            >
                            <template #prev-text>
                                <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                                />
                            </template>
                            </b-pagination>
                        </div>
                        </div>
                    </template>
                </vue-good-table>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import tableauGestionApi from "@/api/tableauGestionApi"
    import miscApi from "@/api/miscApi"
    import moment from "moment"
    import { formatNumber, itemMatch } from "@/services/utils"
    import { confirmDeleteTableauGestion, deleteTableauGestion } from "@/views/setups/tableauGestion"

    import useAppConfig from '@core/app-config/useAppConfig'
    import { computed } from '@vue/composition-api'
    import { mapState, mapGetters, mapMutations } from "vuex"

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

    export default {
        props: {
            context: {default: () => {}}
        },

        components: {
            VueGoodTable,
            ToastificationContent
        },

        data() {
            return {
                tableauxGestion: [],
                initialSortBy: [{field: 'nom', type: 'asc'}],
                pageLength: 25,
                columns: [
                    {
                        label: 'Date',
                        field: 'datePointGestion',
                        filterOptions: {enabled: false, placeholder: 'Date Point Gestion ...', customFilter: true},
                    },
                    {
                        label: 'Validé',
                        field: 'valid',
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        width: '10%',
                        sortable: false
                    },
                ],
            }
        },

        beforeMount() {
            this.refreshTableauxGestion();
        },

        setup() {
            const { skin } = useAppConfig()
            const isDark = computed(() => skin.value === 'dark')

            return { skin, isDark, deleteTableauGestion, confirmDeleteTableauGestion, formatNumber, moment}
        },

        methods: {
            async refreshTableauxGestion() {
                /* console.log(process.env.NODE_ENV == "development") */
                this.tableauxGestion = await tableauGestionApi.getTableauxGestion();
            },

            editTableauGestion(tableauGestionId) {
                this.$router.push({path: `/tableau_gestions/${tableauGestionId}/edit` })
            },

            showToast(variant, text, icon) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        icon,
                        text,
                        variant
                    },
                }, {position: "bottom-right", timeout: 2500})
            },

            deletable(tableauGestion) {
                return !tableauGestion.valid
            },

            removeTableauGestionFromList(tableauGestionId) {
                let index = this.tableauxGestion.findIndex(t => t.id == tableauGestionId)
                if(index != -1)
                    this.tableauxGestion.splice(index, 1)
            }
        }
    }
</script>

<style>
    .dropdown > button{
        padding: 0 !important;
    }
</style>